"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ChartPyramidSolid: function() {
        return ChartPyramidSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ChartPyramidSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M9.36529 3.31111C10.4976 1.20273 13.5216 1.20381 14.6523 3.31302L17.165 8H6.84724L9.36529 3.31111Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M5.77319 10H18.2372L20.3816 14H3.62509L5.77319 10Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M2.55104 16L1.702 17.581C0.628702 19.5796 2.07644 22.0004 4.34499 22.0004H19.6583C21.9259 22.0004 23.3738 19.5814 22.3024 17.5829L21.4538 16H2.55104Z",
            fill: "currentColor"
        })
    ]
}), "ChartPyramidSolid");
const _default = ChartPyramidSolid;
